import { render } from "./HeaderSection.vue?vue&type=template&id=ed2d4746&scoped=true&lang=pug"
const script = {}

import "./HeaderSection.vue?vue&type=style&index=0&id=ed2d4746&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed2d4746"]])

export default __exports__